import { trpc } from '@/data-loaders';
import type { AclUsersFilters } from '#server/models';

export const useExportAreaAclUsers = (areaSlug: string, filters?: AclUsersFilters) =>
  trpc.exportAreaAclUsers.useQuery(
    { areaSlug, ...filters },
    { enabled: false, retry: false }
  );
